module.exports = __webpack_public_path__ + "img/empty.1b9dcfb9.png";